import { useSearchParams } from "react-router-dom";
import { BookOpen, Package, Sparkles, Award } from "lucide-react";
import PageHero from "@/components/shared/PageHero";
import LeadForm from "@/components/shared/LeadForm";

export default function RequestCatalogue() {
  const [sp] = useSearchParams();
  const preset = sp.get("product") ? `Interested in wholesale catalogue for: ${sp.get("product")}` : "";

  return (
    <div>
      <PageHero
        label="Request Catalogue"
        title="Get our latest wholesale catalogue."
        subtitle="Share your business details and our sales team will send the latest digital catalogue tailored to your interests — brand-wise, category-wise, or full portfolio."
        breadcrumbs={[{ label: "Request Catalogue" }]}
      />
      <section className="py-14">
        <div className="mx-auto max-w-6xl px-4 md:px-8 grid md:grid-cols-5 gap-10">
          <div className="md:col-span-2 space-y-6">
            {[
              { icon: BookOpen, t: "Complete Catalogue", d: "PDF & digital catalogues with product photos, SKU details, and MOQ." },
              { icon: Package, t: "Brand-wise Ranges", d: "Filter by 40+ brands to match your retail assortment strategy." },
              { icon: Sparkles, t: "New Arrivals", d: "First look at seasonal drops and trending SKUs every month." },
              { icon: Award, t: "Business Pricing", d: "Wholesale prices shared privately after your business is verified." },
            ].map((f, i) => (
              <div key={i} className="flex gap-4 p-5 rounded-md border border-border/60 bg-card">
                <div className="h-10 w-10 rounded-sm bg-gold/10 text-gold flex items-center justify-center shrink-0">
                  <f.icon size={18} strokeWidth={1.5} />
                </div>
                <div>
                  <h4 className="font-serif text-lg text-foreground">{f.t}</h4>
                  <p className="mt-1 text-sm text-foreground/70">{f.d}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="md:col-span-3">
            <div className="p-8 rounded-md border border-border/60 bg-card">
              <p className="section-label mb-3">Business Details</p>
              <h3 className="serif-display text-3xl text-foreground">Fill the form below.</h3>
              <p className="mt-2 text-sm text-foreground/70">All fields help us send a catalogue tailored to your business.</p>
              <div className="mt-6">
                <LeadForm
                  type="catalogue"
                  presetMessage={preset}
                  submitLabel="Request Catalogue"
                  showFields={["company_name","contact_person","phone","email","gst","business_type","state","city","monthly_purchase","message"]}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
